import { CSSProperties } from 'react'

const commonRow: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
}

const commonImage: CSSProperties = {
  objectFit: 'cover',
}

const sideImageWidth = 293

export const s = {
  root: {
    display: 'flex',
    flexDirection: 'column',
  } as CSSProperties,
  firstRow: {
    ...commonRow,
    marginBottom: 8,
  } as CSSProperties,
  secondRow: {
    ...commonRow,
    fontSize: 24,
  } as CSSProperties,
  cardBody: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
  } as CSSProperties,
  image: {
    ...commonImage,
  } as CSSProperties,
  images: {
    root: {
      width: '100%',
      display: 'flex',
    } as CSSProperties,
    primary: {
      width: `calc(100% - ${sideImageWidth}px)`,
      ...commonImage,
    } as CSSProperties,
    side: {
      width: sideImageWidth,
      display: 'flex',
      flexDirection: 'column',
    } as CSSProperties,
    sideImages: {
      ...commonImage,
    } as CSSProperties,
  },
  tick: {
    gridArea: 'tick',
    fontSize: 60,
    color: '#72C040',
  },
  confirmedAt: {
    gridArea: 'confirmedAt',
    display: 'flex',
    flexDirection: 'column',
  } as CSSProperties,
  venueSpace: {
    fontSize: 24,
    fontWeight: 500,
  } as CSSProperties
}
